var $baaa32ffe5679b1d$exports = {};
$baaa32ffe5679b1d$exports = {
    "backButton": (args)=>`\xc5terg\xe5 till ${args.prevMenuButton}`,
    "moreActions": `Fler \xe5tg\xe4rder`,
    "unavailable": `Ej tillg\xe4nglig, expandera f\xf6r mer information`
};


export {$baaa32ffe5679b1d$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
